
export default function Modal(props) {
    // Editor dialogs pass `light` for the light theme; records views omit it and
    // keep the original dark styling.
    const light = props.light === true;
    return (
        <div className={light ? "stpc-modal stpc-modal-light" : "stpc-modal"} style={{
            width: props.width + 'vw',
            height: props.height + 'vh',
            backgroundColor: light ? '#ffffff' : '#000000',
            border: light ? '1px solid #e4e8ed' : '1px #FAF3DD solid',
            boxShadow: light ? '0 10px 28px rgba(16, 24, 40, .18)' : '#FAF3DD 0px 0px 20px 0.5px',
            color: light ? '#1f2933' : '#FAF3DD',
            borderRadius: light ? '8px' : '0',
            textAlign: 'center',
            position: 'fixed',
            left: '0',
            right: '0',
            top: '0',
            bottom: '0',
            margin: 'auto',
            maxWidth: '100vw',
            maxHeight: '100vw',
            overflow: 'none',
            zIndex: '9',
            marginTop: ("marginTop" in props === true) ? props.marginTop : 'auto'
        }}>
            {props.children}
        </div>
    );
}
